import React from "react";
import styled from "styled-components";
import 'antd/dist/antd.css';
import { Collapse } from 'antd';

const { Panel } = Collapse;

const Container = styled.div`
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    display: flex;

    & > * {
        white-space: pre-wrap;
        font-size: 18px;
        font-weight: 400;
        color: #333333;

        @media only screen and (min-width : 1200px) {
        width: 100%;
        }

        @media only screen and (max-width:768px){
            width: 100%;
        }
        @media only screen and (max-width : 450px){
            width: 100%;
        }
        @media only screen and (max-width : 376px){
            width: 100%;
        }
        
    }
    
    .tidal-container{
        text-align: center;
    }
`;
const callback = (key) => {
}

const textOption1 = `
        มีจำนวนทั้งหมด 9 สถานี ได้แก่ 
        1. สถานีวัดระดับน้ำระนอง จังหวัดระนอง
        2. สถานีวัดระดับน้ำคุระบุรี จังหวัดพังงา
        3. สถานีวัดระดับน้ำทับละมุ จังหวัดพังงา
        4. สถานีวัดระดับน้ำกันตัง จังหวัดตรัง
        5. สถานีวัดระดับน้ำเกาะตะเภาน้อย จังหวัดภูเก็ต
        6. สถานีวัดระดับน้ำแหลมพันวา จังหวัดภูเก็ต
        7. สถานีวัดระดับน้ำเกาะชีหรือเกาะสต๊อร์ก หมู่เกาะสุรินทร์ จังหวัดพังงา
        8. สถานีวัดระดับน้ำเกาะเมียง หมู่เกาะสิมิลัน จังหวัดพังงา
        9. สถานีวัดระดับน้ำเกาะตะรุเตา จังหวัดสตูล
  `;

const textOption2 = `
        ระดับทะเลปานกลางมาตรฐาน (Mean Sea Level หรือ MSL) หมายถึง ระดับทะเลเฉลี่ยที่คำนวณหาได้จากผลการตรวจระดับน้ำทะเลทุกช่วงเวลาเท่า ๆ 
        กัน เป็นระยะเวลานาน (The average sea level calculated from a long series of observations obtained at equal interval of time)
        สำหรับระดับทะเลปานกลางมาตรฐานของประเทศไทยนั้นได้จากการคำนวณหาค่าเฉลี่ยจากผลการตรวจวัดระดับน้ำที่เกาะหลักจ.ประจวบคีรีขันธ์ 
        ระหว่างเดือนตุลาคม พ.ศ. 2453 ถึงเดือนตุลาคม พ.ศ. 2458
  `;

const textOption3 = `
        ค่ารายการน้ำเป็นข้อมูลระดับน้ำที่ได้จากการตรวจวัดระดับน้ำเป็นเวลานาน โดยควรตรวจวัดให้ครอบคลุมเวลา 18.6 ปี หรือ 1รอบวัฏจักรน้ำ ซึ่งในทางปฏิบัติแล้วจะใช้ช่วงเวลา 19 ปีในการเก็บรวบรวมข้อมูลแล้วคำนวณออกมาเป็นค่ารายการน้ำ (Tidal Information)โดยความหมายของค่ารายการน้ำต่าง ๆ มีดังนี้
        น้ำขึ้นสูงสุด (Highest High Water หรือ H’est HW) หมายถึง น้ำขึ้นสูงสุดในช่วงเวลาที่ตรวจวัดข้อมูล
        น้ำขึ้นเต็มที่ยอดสูงปานกลาง (Mean Higher Water หรือ MHHW) หมายถึง ในวันที่มีน้ำขึ้นเต็มที่ 2 ครั้ง ความสูงของน้ำย่อมไม่เท่ากัน น้ำขึ้นเต็มที่ที่สูงกว่า เรียกว่า น้ำขึ้นเต็มที่ยอดสูง (Higher High Water) เมื่อนำค่าน้ำขึ้นเต็มที่ยอดสูงมาหาค่าเฉลี่ยจะเรียกว่า “น้ำขึ้นเต็มที่ยอดสูงปานกลาง"
        น้ำขึ้นเต็มที่ปานกลางหน้าน้ำเกิด (Mean High Water Spring หรือ MHWS) หมายถึง ค่าเฉลี่ยน้ำขึ้นเต็มที่ในช่วงเดือนมืดหรือเดือนเพ็ญ (แรม 15 ค่ำหรือขึ้น 15 ค่ำ)
        น้ำขึ้นเต็มที่ปานกลาง (Mean High Water หรือ MHW) หมายถึง ค่าเฉลี่ยของระดับน้ำขึ้นเต็มที่ทั้งหมด
        น้ำขึ้นเต็มที่ปานกลางหน้าน้ำตาย (Mean High Water Neap หรือ MHWN) หมายถึง ค่าเฉลี่ยน้ำขึ้นเต็มที่ในช่วงกึ่งปักษ์ (ขึ้น 8 ค่ำ หรือแรม 8 ค่ำ)
        ระดับน้ำปานกลางหรือกึ่งระดับน้ำ (Mean Tide Level หรือ MTL) หมายถึง ค่ากึ่งกลางของความสูงระหว่างระดับน้ำขึ้นเฉลี่ยกับระดับน้ำลงเฉลี่ย ค่ากึ่งกลางระดับน้ำนี้มีค่าใกล้เคียงกับระดับทะเลปานกลางท้องถิ่น
        ระดับทะเลปานกลางท้องถิ่น (Local Mean Sea Level หรือ LMSL) หมายถึง ระดับทะเลเฉลี่ยของตำบลที่ตรวจระดับน้ำนั้น ๆ ที่คำนวณหาได้จากผลการตรวจระดับน้ำทะเลทุกช่วงเวลาที่เท่า ๆ กันเป็นระยะเวลานาน
        น้ำลงเต็มที่ปานกลางหน้าน้ำตาย (Mean Low Water Neap หรือ MLWN) หมายถึง ค่าเฉลี่ยน้ำลงเต็มที่ในช่วงกึ่งปักษ์ (ขึ้น 8 ค่ำ หรือแรม 8 ค่ำ)
        น้ำลงเต็มที่ปานกลาง (Mean Low Water หรือ MLW) หมายถึง ค่าเฉลี่ยของระดับน้ำลงเต็มที่ทั้งหมด
        น้ำลงเต็มที่ปานกลางหน้าน้ำเกิด (Mean Low Water Spring หรือ MLWS) หมายถึง ค่าเฉลี่ยของน้ำลงเต็มที่ในช่วงเดือนมืดหรือเดือนเพ็ญ (แรม 15 ค่ำหรือขึ้น 15 ค่ำ)
        น้ำลงเต็มที่ยอดต่ำปานกลาง (Mean Lower Low Water หรือ MLLW) หมายถึง ในวันที่มีน้ำลงเต็มที่ 2 ครั้ง ความสูงของน้ำลงเต็มที่ย่อมไม่เท่ากันน้ำลงเต็มที่ที่ต่ำกว่า เรียกว่า “น้ำลงเต็มที่ยอดต่ำ” (Lower Low Water) เมื่อนำค่าน้ำลงเต็มที่ยอดต่ำมาหาค่าเฉลี่ย เรียกว่า “น้ำลงเต็มที่ยอดต่ำปานกลาง”
        พิสัยน้ำเกิดปานกลาง (Mean Spring Range หรือ Mn.Sg.Range) หมายถึง ค่าเฉลี่ยพิสัย (Range) ของน้ำหน้าน้ำเกิด
        พิสัยน้ำตายปานกลาง (Mean Neap Range หรือ Mn.Np.Range) หมายถึง ค่าเฉลี่ยพิสัย (Range) ของน้ำหน้าน้ำตาย
        พิสัยน้ำ (Mean Range หรือ Mn.Range) หมายถึง ค่าเฉลี่ยระหว่างระดับน้ำขึ้นปานกลางกับระดับน้ำลงปานกลาง
        น้ำลงต่ำที่สุด (Lowest Low Water หรือ L’est LW) หมายถึง ระดับน้ำลงเต็มที่ต่ำที่สุดในช่วงเวลาที่ตรวจวัดข้อมูลดในช่วงเวลาที่ตรวจวัดข้อมูล

`;

export default function Index(props) {
    return(
        <Container>
            <Collapse collapse defaultActiveKey={['1']} onChange={callback}>
                <Panel header="สถานีวัดระดับน้ำดิจิทัลที่ใช้ติดตามเพื่อช่วยการเตือนภัยสึนามิฝั่งทะเลอันดามัน ที่อยู่ในความรับผิดชอบของกรมอุทกศาสตร์ ปัจจุบันมีจำนวนทั้งหมดกี่สถานี ?" key="1">
                    <p>{textOption1}</p>    
                </Panel>
                <Panel header="ระดับ MSL คือระดับอะไร ?" key="2">
                    <p>{textOption2}</p>
                </Panel>
                <Panel header="ค่ารายการน้ำของการตรวจวัดระดับน้ำหมายถึงอะไร ?" key="3">
                    <p>{textOption3}</p>
                    <div className="tidal-container">
                        <img src="./image/tidal2.gif" alt=""/>
                        <p>รูปแสดงความสัมพันธ์ของค่ารายการน้ำ</p>
                    </div>
                    
                </Panel>
            </Collapse>
        </Container>
    ) 
}